export default {
  id: 83,
  title: 'Target #83 - Supernova',
  url: 'https://cssbattle.dev/play/83',
  colors: ['#243D83', '#6592CF', '#EEB850'],
  solution:
    '<a a><a b><a c><style>[b],body{background:#243d83}[a],[c]{border-radius:9in}a{position:fixed}[a]{top:58;left:108;width:100;height:100;background:#6592cf;box-shadow:85px 0 #6592cf,0 85px #6592cf,85px 85px #6592cf}[b]{top:90;left:140;width:120;height:120;transform:rotate(45deg)}[c]{top:120;left:170;width:60;height:60;background:#eeb850}</style>',
}
